<div class="h-100 w-100 d-flex flex-column flex-grow-1 overflow-auto" [dir]="isRTL ? 'rtl' : 'ltr'">

  <div class="position-absolute w-100 d-flex zx-z-index-1" [class.justify-content-end]="isRTL">
    <button type="button" mat-icon-button aria-label="Close" (click)="closeDialog()"
      class="close-icon d-flex align-items-center justify-content-center" [class.text-white]="isDarkMode">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <div class="d-flex flex-grow-1 flex-column align-items-center px-3 pt-4 pb-3 px-md-4 pt-md-5 gap-3 w-100 position-relative">

    <!-- כותרת לפי מצב -->
    <h4 class="text-center fw-bold m-0 pt-3 pt-lg-0" [class.text-white]="isDarkMode">
      <span *ngIf="isCreditMode">{{ "credit-order.title-credit" | translate }}</span>
      <span *ngIf="isPointsMode">{{ "credit-order.title-points" | translate }}</span>
    </h4>

    <!-- טקסט אישור לפי מצב -->
    <p class="text-center m-0 pt-2" [class.zx-text-white]="isDarkMode" [class.zx-ltr]="!isRTL">
      <!-- זיכוי באשראי – רק אשראי -->
      <ng-container *ngIf="isCreditMode && getPoints() <= 0">
        {{ "credit-order.confirm-credit-only" | translate: { amount: roundAmount(getAmount()), orderId: orderIdPrefix } }}
      </ng-container>
      <!-- זיכוי באשראי – אשראי + נקודות -->
      <ng-container *ngIf="isCreditMode && getPoints() > 0">
        {{ "credit-order.confirm-credit-and-points" | translate: { amount: roundAmount(getAmount()), points: getPoints(), orderId: orderIdPrefix } }}
      </ng-container>
      <!-- זיכוי בנקודות – מציג סכום אשראי + סכום נקודות -->
      <ng-container *ngIf="isPointsMode">
        {{ "credit-order.confirm-points" | translate: { orderId: orderIdPrefix, points: roundAmount(getTotalCreditAndPoints()) } }}
      </ng-container>
    </p>

    <div class="d-flex flex-column flex-sm-row justify-content-center align-items-center gap-2 w-100 pt-3">
      <button type="button" (click)="performRefund()" [disabled]="isLoading" mat-raised-button
        class="rounded-pill flex-grow-1 fw-bold text-white credit-order-btn-confirm">
        {{ "credit-order.btn-confirm" | translate }}
      </button>
      <button (click)="closeDialog()" mat-button class="rounded-pill flex-grow-1 fw-bold credit-order-btn-cancel">
        {{ "su-management.branches_cancel" | translate }}
      </button>
    </div>

    <div *ngIf="isLoading" class="d-flex justify-content-center py-3">
      <mat-spinner diameter="32"></mat-spinner>
    </div>
  </div>
</div>
